import React from "react";
import { motion, useReducedMotion } from "motion/react";

// Scroll-reveal wrapper used by the styleguide as the first trial of the motion
// stack. Each section springs up + fades in the first time it enters the
// viewport. Reduced-motion users get the content immediately with no transform.
//
// Spring (not linear) per the master-frontend Motion phase; `once: true` so
// sections don't re-animate on every scroll pass; `amount: 0.15` triggers as
// soon as a sliver is visible so nothing feels laggy.
const MotionSection = ({ children, className, id, delay = 0 }) => {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <section className={className} id={id}>
        {children}
      </section>
    );
  }

  return (
    <motion.section
      className={className}
      id={id}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ type: "spring", stiffness: 260, damping: 30, delay }}
    >
      {children}
    </motion.section>
  );
};

export default MotionSection;
